import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useSetTitlePage = (title, loadSuccess) => {
  const location = useLocation();

  useEffect(() => {
    const savedTitle = localStorage.getItem('pageTitle');
    const savedUrl = localStorage.getItem('pageUrl');
    if (savedTitle && savedUrl === window.location.href && !loadSuccess) {
      document.title = savedTitle;
    }
  }, [window.location.href]);

  useEffect(() => {
    if (loadSuccess && title) {
      document.title = title || '';

      // Reassign fullUrl on page transition (Only works when piTracker is displayed for the first time)
      if (typeof window.piTracker === 'function') {
        const fullUrl = `${window.location.origin}/#${location?.pathname}${location?.search}${location?.hash}`;
        window.piTracker(fullUrl);
      }

      localStorage.setItem('pageTitle', title);
      localStorage.setItem('pageUrl', window.location.href);
    }
  }, [title, loadSuccess]);
};

export default useSetTitlePage;
